import { createContext, useContext } from "react"

const AuthContext = createContext<{ token: string } | undefined>(undefined)
AuthContext.displayName = "AuthContext"

const useAuth = () => {
  const context = useContext(AuthContext)

  if (!context) {
    throw new Error("useAuth must be used within a AuthProvider")
  }

  return context
}

export { AuthContext, useAuth }
